import { RequestVersionedApi, RequestApi } from '@helpers';

const getemployeeProfile = (employeeID) => RequestVersionedApi.get(`/Employees/employeeProfile?employeeID=${employeeID}`);

const getListOfEmployeeProfiles = (employeeID, searchRequest) => RequestVersionedApi.get(`Employees/listOfEmployees?searchText=${searchRequest}&adminID=1986211`);

const getFilterValues = (employeeID) => RequestApi.get(`/CDM/filterValues?employeeID=${employeeID}`);

const getManufacturersList = () => RequestApi.get(`/CDM/covidManufacturers`);

const getCerts = (employeeNum) => RequestApi.get(`/Certificate/employeeCerts?EmployeeID=${employeeNum}`);

const getCertificateImage = (payload) => RequestApi.post(`/Certificate/getImage`, payload);

const addUpdateCertificates = (payload) => RequestApi.post(`/Certificate/addUpdateNewCert`, payload);

const getStateDLFormat = (state) => RequestApi.get(`/CDM/stateDLFormat?State=${state}`);

const getEcardDetails = (employeeID, eCardNumber, certificateID) => RequestApi.get(`/CDM/getECardDetails?eCardNumber=${eCardNumber}&employeeID=${employeeID}&certificateID=${certificateID}`);

const eCardMapping = () => RequestApi.get("/CDM/ecardMapping?codeType=ECARD");

const getCertificatesTypes = () => RequestApi.get("/CDM/certificateTypes");

const getCountiesList = () => RequestApi.get("CDM/counties");

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getemployeeProfile,
    getListOfEmployeeProfiles,
    getFilterValues,
    getCerts,
    getCertificateImage,
    getManufacturersList,
    addUpdateCertificates,
    getStateDLFormat,
    getEcardDetails,
    eCardMapping,
    getCertificatesTypes,
    getCountiesList,
};